// extracted by mini-css-extract-plugin
export default {"pageMenu":"PageMenu__pageMenu___NlgKV","item":"PageMenu__item___OTaV2","active":"PageMenu__active___GdDmn","divider":"PageMenu__divider___aNbfZ"};